module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "series"
    }
  }, [_c('p', {
    staticClass: "sert"
  }, [_vm._v("Books by Ralph Peters")]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_vm._v("Nonfiction")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Endless War")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Looking for Trouble")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Wars of Blood and Faith")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("New Glory")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Never Quit the Fight")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Beyond Baghdad")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Beyond Terror")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Fighting for the Future")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_vm._v("Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("The Officers’ Club")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("The War After Armageddon")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Traitor")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("The Devil’s Garden")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Twilight of Heroes")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("The Perfect Soldier")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Flames of Heaven")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("The War in 2020")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Red Army")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Bravo Romeo")]), _vm._v(" "), _c('p', {
    staticClass: "sers"
  }, [_vm._v("Writing as Owen Parry")]), _vm._v(" "), _c('p', {
    staticClass: "serah"
  }, [_vm._v("Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Rebels of Babylon")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Bold Sons of Erin")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Honor’s Kingdom (Hammett Award)")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Call Each River Jordan")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Shadows of Glory")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Faded Coat of Blue (Herodotus Award)")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Our Simple Gifts")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_vm._v("Strike the Harp")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca6fdfb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spblinesoffire0002.vue
// module id = 57
// module chunks = 0